import React, { useEffect, useState } from 'react'
import { Link } from 'gatsby'
import { useMedia } from 'react-media'

import benefitsList from '../data/benefitsList'

import logo from '../images/gain-logo-white.svg'
import logoBg from '../images/gain-logo-simple.svg'

function Header({ headerMode }) {
	const isSmallScreen = useMedia({ query: '(max-width: 780px)' })
	const [scrolled, setScrolled] = useState(isSmallScreen)

	const handleScroll = () => setScrolled(window && window.scrollY >= 250)
	const handleResize = () => setScrolled(window && window.innerWidth <= 780)

	useEffect(() => {
		window && window.addEventListener('resize', handleResize)

		window &&
			headerMode !== 'fixed' &&
			!isSmallScreen &&
			window.addEventListener('scroll', handleScroll)

		return () => {
			window.removeEventListener('resize', handleResize)
			window.removeEventListener('scroll', handleScroll)
		}
		// eslint-disable-next-line
	}, [])

	return (
		<header className={`site-header ${scrolled || headerMode === 'fixed' ? 'scrolled' : ''}`}>
			<div className='inner-header'>
				<h1
					className='logo'
					data-aos='fade-down'
					style={{ backgroundImage: `url(${scrolled || headerMode === 'fixed' ? logoBg : ''})` }}>
					<img src={logo} alt='GAIN' />
				</h1>
				<nav className='main-nav'>
					<ul className='navigation-list'>
						<li>
							<Link
								to='/'
								onClick={e => {
									if (headerMode !== 'fixed') {
										e.preventDefault()
										window.scrollTo(0, 0)
										window.history.pushState('', '', '/')
									}
								}}>
								Inicio
							</Link>
						</li>
						<li>
							<Link to='/#quienes-somos'>Quienes Somos</Link>
						</li>
						<li>
							<Link to='/#servicios'>Servicios</Link>
						</li>
						<li>
							<Link
								to='/#beneficios'
								className='benefits-link'
								onClick={e => {
									headerMode === 'fixed' && e.preventDefault()
								}}>
								<span>Beneficios</span>
								{headerMode === 'fixed' && (
									<div className='benefits-list'>
										{benefitsList().map(link => (
											<Link
												className='benefits-list__link'
												to={`/beneficios/${link.url}`}
												key={link.url}>
												{link.text}
											</Link>
										))}
									</div>
								)}
							</Link>
						</li>
						<li>
							<Link to='/#contacto'>Contacto</Link>
						</li>
					</ul>
				</nav>
			</div>
		</header>
	)
}

export default Header
